//publishing + formatting + validation utility functions for twitter
var twitter = require('twitter-text');

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import { client } from '../http';

const bannedMentions = [
  'PMOIndia',
  'HMOIndia',
  'DoPTGoI',
  'DrJitendraSingh',
  'RSSorg',
  'MinistryWCD',
  'myogiadityanath',
  'DelhiPolice',
  'Uppolice',
  'TwitterIndia',
  'itsSSR',
];

const blockedHandles = [
  //make these lowercase
  'its_sush_fan',
  'khushi4justice',
  'sushabelieber',
  'foreversushh',
  'sushassrian',
  'sushantmunjal',
];

const spamWords = [
  'Sushant',
  'SushantSingh',
  'SushantSinghRajput',
  'SushantRajput',
  //added space to ssr so words using ssr are allowed
  'ssr ',
  ' ssr ',
  ' ssr',
  'CBISilence',
  'CBIS',
  'Rajput',
  'Rajputin',
  'CBI Silence',
  'Warrior4SSR',
  'ssrwarrior',
  'ssrian',
  'ssrwarrior',
];

//this function validates the thread and returns an array that can be sent to Twitter
//this should probably be done on the server side
export async function formatThread({
  rawTweetArray,
  imageIDArray,
  imageDataArray,
  twitterThreadText,
  twitterHandle,
  galleryUsername,
  userID,
  tSlug,
}) {
  async function spamCheck() {
    var text = twitterThreadText;
    var spam = false;
    var usernames = twitter.default.extractMentions(text.toLowerCase());
    var reasons = [];

    if (blockedHandles.includes(twitterHandle.toLowerCase())) {
      return true;
    }

    var mentions = {};
    for (var i = 0; i < usernames.length; i++) {
      if (mentions[usernames[i]]) {
        mentions[usernames[i]]++;
      } else {
        mentions[usernames[i]] = 1;
      }
    }

    //if any mention is used more than 2 times, it is considered spam
    for (var key in mentions) {
      if (mentions[key] >= 3) {
        spam = true;
      }
    }

    if (usernames.length > 6) {
      //
      spam = true;
      reasons.push('Too many mentions');
    } else {
    }

    //check if text includes any spam words
    spamWords.forEach((word) => {
      if (text.toLowerCase().includes(word.toLowerCase())) {
        //
        spam = true;
        reasons.push('Thread marked as spam');
      }
    });

    //check if any of the usernames are banned

    usernames.forEach((username) => {
      bannedMentions.forEach((bannedUsername) => {
        //set both to lowercase
        if (username.toLowerCase() === bannedUsername.toLowerCase()) {
          //
          spam = true;
          reasons.push('Thread marked as spam');
        }
      });
    });

    //get length of tweet array
    var length = rawTweetArray.length;

    if (length > 25) {
      //long thread potential span
      spam = true;
      reasons.push('Tweet array too long');
    }

    const limit = await checkLimit();

    if (limit > 25) {
      //more than 25 tweets in the last hour
      spam = true;
      reasons.push('Too many tweets recently');
    } else {
      //
    }
    return { spam, reasons };
  }

  async function checkLimit() {
    let tweetsInLastHour = 0;

    let threads = [];
    let typeshares = [];

    const snapshot = await firebase
      .database()
      .ref('users/' + userID + '/threads/')
      .once('value');
    if (snapshot.exists()) {
      snapshot.forEach((childSnapshot) => {
        threads.push(childSnapshot.key);
      });
    }

    const typesharesRef = await firebase
      .database()
      .ref('gallery/' + galleryUsername + '/' + userID + '/typeshares/')
      .once('value');
    if (typesharesRef.exists()) {
      typesharesRef.forEach((childSnapshot) => {
        typeshares.push(childSnapshot.key);
      });
    }

    threads.forEach((thread) => {
      tweetsInLastHour += limit2(thread);
    });

    //make an async loop that awaits limit3 and increment tweetsInLastHour

    for (let i = 0; i < typeshares.length; i++) {
      tweetsInLastHour += await limit3(typeshares[i]);
    }

    return tweetsInLastHour;
  }

  const limit2 = (tSlug) => {
    var tweetsInLastHour = 0;
    const dbRef = firebase
      .database()
      .ref('users/' + userID + '/threads/' + tSlug)
      .child('published');
    dbRef.once('value', (snapshot) => {
      if (snapshot.hasChild('publishedAt')) {
        const unixTime = snapshot.val().publishedAt.unix;
        const currentTime = new Date().getTime();
        const timeDiff = currentTime - unixTime;
        const tweetIDs = snapshot.val().tweetIDs;
        const numberOfTweets = snapshot.hasChild('tweetIDs')
          ? tweetIDs.length
          : rawTweetArray.length;

        if (timeDiff / 3600000 > 1) {
          tweetsInLastHour += 0;
        } else {
          tweetsInLastHour += numberOfTweets;
        }
      } else {
        //router.push("/")
      }
    });
    return tweetsInLastHour;
  };

  async function limit3(tSlug) {
    var tweetsInLastHour = 0;
    const snapshot = await firebase
      .database()
      .ref('gallery/' + galleryUsername + '/' + userID + '/typeshares/')
      .child(tSlug)
      .once('value');
    if (snapshot.exists()) {
      if (snapshot.hasChild('publishedAt')) {
        const unixTime = snapshot.val().publishedAt.unix;
        const currentTime = new Date().getTime();
        const timeDiff = currentTime - unixTime;
        const numberOfTweets = snapshot.hasChild('preview/published/twitter')
          ? snapshot.hasChild('threadMeta/tweetIDs')
            ? snapshot.val().threadMeta.tweetIDs.length
            : 1
          : 0;

        if (timeDiff / 3600000 > 1) {
          return 0;
        } else {
          return numberOfTweets;
        }
      } else {
        return 0;
        //router.push("/")
      }
    } else {
      return 0;
    }
  }

  var isReady = rawTweetArray.map(function (item, index2) {
    if (twitter.default.parseTweet(item).valid === true) {
      return true;
    } else {
      return false;
    }
  });

  const allEqual = (arr) => arr.every((v) => v === true);

  if (allEqual(isReady) === true) {
    const spam = await spamCheck();

    if (spam.isSpam) {
      return { success: false, message: spam.reasons[0] };
    } else {
      var b64ImagesData = [];

      Object.keys(imageIDArray).map(function (key, index) {
        //check if imageIDArray[key] is null
        if (imageIDArray[key] !== null) {
          var someArray = [];
          Object.keys(imageIDArray[key]).map(function (key2, index2) {
            var imageData = imageIDArray[key]
              ? imageIDArray[key][key2]
                ? imageDataArray[imageIDArray[key][key2]]
                  ? imageDataArray[imageIDArray[key][key2]].replace(
                      /^data:image\/[a-z]+;base64,/,
                      '',
                    )
                  : null
                : null
              : null;
            imageData && someArray.push(imageData);
          });
          b64ImagesData[index] = someArray;
        }
      });

      var formattedOutput = [];
      rawTweetArray.forEach(function (item, index2) {
        //check if b64ImagesData[index2] is null
        if (
          b64ImagesData[index2] !== null &&
          b64ImagesData[index2] !== undefined
        ) {
          var imgData = b64ImagesData[index2];
          formattedOutput.push({
            text: item,
            options: { media_data: imgData },
          });
        } else {
          formattedOutput.push({ text: item });
        }
      });

      return { success: true, data: formattedOutput };
    }
  } else {
    //async loop that checks if each tweet is valid

    const validate = await rawTweetArray.map(async function (item, index2) {
      var parse = twitter.default.parseTweet(item);

      if (parse.valid === true) {
        return { success: true };
      } else {
        if (parse.weightedLength === 0) {
          return {
            success: false,
            message: `Tweet number ${index2 + 1} is blank`,
          };
        } else if (parse.weightedLength > 280) {
          return {
            success: false,
            message: `Tweet number ${index2 + 1} is too long`,
          };
        } else {
          return {
            success: false,
            message: `Tweet number ${index2 + 1} is invalid`,
          };
        }
      }
    });

    const allValid = await Promise.all(validate);

    const allEqual = (arr) => arr.every((v) => v.success === true);

    if (allEqual(allValid) === true) {
      return { success: false, message: 'Something went wrong' };
    } else {
      return { success: false, message: allValid[0].message };
    }
  }
}

//this thread publishes the thread to twitter at a scheduled time
export async function tweetScheduledThread({ tweetArray, unix, userID, slug }) {
  try {
    const { data } = await client.post('/api/create/thread', {
      timestamp: unix,
      data: { userID, slug },
    });
    if (!data.success) {
      throw new Error('cannot tweet scheduled thread');
    }
    const postbackID = data.id;
    //if response is successful, add the thread to the database
    await firebase
      .database()
      .ref('users/' + userID + '/threads/' + slug)
      .child('published')
      .update({
        publishedAt: {
          unix: unix,
        },
        oneEditor: true,
        schedulingVersion: 'V2',
        scheduleID: postbackID,
        formattedTweetData: tweetArray,
      });

    return { success: true, data };
  } catch (err) {
    console.error(err);
    return { success: false, message: "Couldn't schedule thread" };
  }
}

async function getImageDimensions(file) {
  return new Promise(function (resolved, rejected) {
    var i = new Image();
    i.onload = function () {
      resolved({ w: i.width, h: i.height });
    };
    i.src = file;
  });
}

export async function validateImage({ tweetText, essayImage }) {
  try {
    if (tweetText.length > 0) {
      if (twitter.default.parseTweet(tweetText).valid === true) {
        var usernames = twitter.default.extractMentions(
          tweetText.toLowerCase(),
        );

        //check if any duplicate mentions exist
        var duplicate = false;
        var mentions = {};
        for (var i = 0; i < usernames.length; i++) {
          if (mentions[usernames[i]]) {
            mentions[usernames[i]]++;
          } else {
            mentions[usernames[i]] = 1;
          }
        }

        for (var key in mentions) {
          if (mentions[key] >= 2) {
            duplicate = true;
          }
        }

        if (usernames.length >= 4) {
          duplicate = true;
        }

        if (duplicate) {
          return {
            success: false,
            message: "You can't mention the same user twice",
          };
        } else {
          var b64 = essayImage.replace('data:image/png;base64,', '');
          var dimensions = await getImageDimensions(essayImage);

          if (dimensions.h < 8000) {
            //ALL GOOD
            return { success: true };
          } else {
            return {
              success: false,
              message:
                'Image is too large for Twiter. Please reduce the font size or download and share the image manually.',
            };
          }
        }
      } else {
        return { success: false, message: 'Your tweet is too long' };
      }
    } else {
      return { success: false, message: 'You need some Tweet text' };
    }
  } catch (error) {
    console.log(error);
    return { success: false, message: 'Something went wrong' };
  }
}

export async function scheduleEssayImage({
  unix,
  galleryUsername,
  userID,
  activeTypeshareID,
  tweetText,
  altText,
  attachLink,
  b64,
  currentSlug,
  passedCollectionID,
}) {
  try {
    console.log('SCHEDULING ESSAY IMAGE');
    const { data } = await client.post('/api/scheduling/schedule-tweet', {
      timestamp: unix,
      data: {
        sentry: {
          username: galleryUsername,
          id: userID,
          postID: activeTypeshareID,
        },
        userID: userID,
        slug: activeTypeshareID,
      },
    });
    if (!data.success) {
      throw new Error('unable to schedule essay image');
    }
    const postbackID = data.id;
    const essayUserRef = firebase
      .database()
      .ref('users/' + userID + '/typeshares/' + activeTypeshareID);

    await essayUserRef.child('tweetSchedule').update({
      b64: b64,
      scheduleID: postbackID,
      tweetText: tweetText,
      altText: altText,
      attachLink: attachLink,
      collectionID: passedCollectionID ? passedCollectionID : null,
      customSlug: currentSlug,
      schedulingVersion: 'V2',
    });

    return { success: true };
  } catch (error) {
    console.log(error);
    return { success: false };
  }
}
